import { UPDATE_ASSIGNED_SECTIONS } from '../../actions';

export default (props, payload) => {
  const { dispatch } = props;
  dispatch({
    type: UPDATE_ASSIGNED_SECTIONS,
    payload,
  });
};
